// extracted by mini-css-extract-plugin
export default {"inputDefaults":"style_inputDefaults__j2uJ8"};